import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-525238df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hidden md:block flex-none align-items-center justify-content-center font-bold py-3" }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = {
  class: "font-bold ml-2",
  style: {"color":"black"}
}
const _hoisted_4 = { class: "flex-none flex align-items-center justify-content-center font-bold py-3" }
const _hoisted_5 = { class: "block md:hidden flex-none align-items-center justify-content-center font-bold py-3" }
const _hoisted_6 = { class: "hidden md:block flex-grow-1 align-items-center justify-content-center px-5 py-3" }
const _hoisted_7 = { class: "hidden md:block flex-none align-items-center justify-content-center font-bold mr-3 py-3" }
const _hoisted_8 = { class: "flex-none flex align-items-center justify-content-center font-bold py-2" }
const _hoisted_9 = { class: "flex align-items-center gap-4 mr-2" }

export function render(_ctx, _cache) {
  const _component_p_avatar = _resolveComponent("p-avatar")
  const _component_router_link = _resolveComponent("router-link")
  const _component_p_button = _resolveComponent("p-button")
  const _component_app_global_search = _resolveComponent("app-global-search")
  const _component_app_sub_menu = _resolveComponent("app-sub-menu")
  const _component_app_notif_menu = _resolveComponent("app-notif-menu")
  const _component_app_user_menu = _resolveComponent("app-user-menu")

  return (_openBlock(), _createElementBlock("div", {
    class: "layout-topbar inline-flex",
    style: _normalizeStyle({'background-color' :  _ctx.app_base_data.main_theme_color , 'color' : 'black'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/home" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, [
              _createVNode(_component_p_avatar, {
                image: _ctx.app_base_data.main_icon,
                shape: "circle"
              }, null, 8, ["image"])
            ]),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.app_base_data.app_name), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_p_button, {
        icon: "pi pi-bars",
        severity: "info",
        rounded: "",
        outlined: "",
        class: "layout-menu-button",
        style: {"color":"black"},
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.toggleAppSide()))
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_app_global_search)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu_items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex inline-flex align-items-center"
        }, [
          _createVNode(_component_app_sub_menu, { menu: item }, null, 8, ["menu"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_app_global_search)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_app_notif_menu),
        _createVNode(_component_app_user_menu)
      ])
    ])
  ], 4))
}